import { render } from "./new-featured-vertical-text.vue?vue&type=template&id=caf30800&scoped=true&lang=html"
import script from "./new-featured-vertical-text.vue?vue&type=script&lang=js"
export * from "./new-featured-vertical-text.vue?vue&type=script&lang=js"

import "./new-featured-vertical-text.vue?vue&type=style&index=0&id=caf30800&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf30800"]])

export default __exports__